import {
  Component, ComponentFactoryResolver, Inject, OnDestroy, OnInit, Type, ViewChild,
  ViewContainerRef
} from '@angular/core';
import { Subscription } from 'rxjs';
import { fuseAnimations } from '@barebone-fuse/@fuse/animations';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InboxModel } from '../../models/inbox.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { InboxState } from '../../store/reducers/inbox.reducers';
import { Store } from '@ngrx/store';
import { GetMailByIdAction } from '../../store/actions/inbox.actions';
import { getCurrentMail } from '../../store/selectors/inbox.selectors';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';
import { RootDynamicComponentHelper } from '@shared/helpers/root-dynamic-component-helper';
import { Input } from '@angular/core';



@Component({
    standalone: false,
    selector   : 'mail-template-content',
    templateUrl: './mail-template-content.component.html',
    styleUrls  : ['./mail-template-content.component.scss'],
    animations : fuseAnimations
})
export class MailTemplateContentComponent implements OnInit, OnDestroy
{


    @Input() mailContent: any;
    labels: any[];
    unSubscribe$ = new Subject<void>();
    currentMailId:string;
    data: DialogModel;
    @ViewChild('mailTemplateComponentHost', {read: ViewContainerRef, static: true}) mailTemplateComponentHostRef;
    constructor(
                private store: Store<InboxState>,
                private componentFactoryResolver: ComponentFactoryResolver

    )
    {

    }

    ngOnInit()
    {
      this.loadTemplate();
    }
    loadTemplate(){
      const componentName = this.mailContent.type;
      let currentComponent = <Type<any>>RootDynamicComponentHelper.getComponent(componentName);
      if(!currentComponent) {
        currentComponent = <Type<any>>RootDynamicComponentHelper.getComponent('ReplyMessageView');
      }
      const componentRef = this.mailTemplateComponentHostRef.createComponent(currentComponent);
      const templateComponent = componentRef.instance as any;
      templateComponent.item = this.mailContent;
    }

    ngOnDestroy()
    {
      this.unSubscribe$.next();
      this.unSubscribe$.complete();
    }


}
